<div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card style="min-width: 400px; transition: none !important; box-shadow: none !important;">
        <mat-card-title>
            <div style="margin: 20px" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                <span>Cancelar Turno</span>
            </div>
        </mat-card-title>
        <mat-card-content>
            <div fxLayout="column" fxLayoutWrap="wrap">
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" style="margin: 10px 0 0 0;">
                    <mat-form-field fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                        <textarea matInput [placeholder]="'Motivo'" rows="3"
                            [(ngModel)]="appointment.cancelNote"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                    <mat-slide-toggle [(ngModel)]="reassign" (change)="changed()">
                        Reasignar nuevo turno
                    </mat-slide-toggle>
                </div>

                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" *ngIf="reassign">
                    <mat-form-field fxFlex.gt-sm="70" fxFlex.gt-xs="70" fxFlex="70">
                        <input matInput [matDatepicker]="picker" [min]="minDate" placeholder="Seleccionar fecha"
                            [(ngModel)]="dateFrom">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div style="height: 150px;" *ngIf="dateFrom">
                    <div>
                        <h4>Nuevo Turno</h4>
                        <p>Fecha: <strong>{{dateFrom | date:"dd/MM/yyyy"}}</strong></p>

                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer>
            <div style="margin: 20px; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                <button (click)="closeDialog()" mat-button color="primary">Cancelar</button>
                <button (click)="doAction()" mat-raised-button color="warn">Aceptar</button>
            </div>
        </mat-card-footer>
    </mat-card>
</div>